import { Controller } from "@hotwired/stimulus"

export default class extends Controller {


  connect() {
    document.getElementById("counters-form").requestSubmit()
  }

  // refresh() {
  //   document.getElementById("counters-form").requestSubmit()
  // }


}